import React from 'react';
import './ExitConfirmation.css';

const ExitConfirmation = ({ onConfirm, onCancel }) => {
  return (
    <div className="exit-confirmation-overlay">
      <div className="exit-confirmation-container">
        {/* Background decoration */}
        <div className="exit-bg-decoration">
          <div className="exit-circle exit-circle-1"></div>
          <div className="exit-circle exit-circle-2"></div>
          <div className="exit-circle exit-circle-3"></div>
        </div>

        <div className="exit-content">
          {/* Icon */}
          <div className="exit-icon">
            <span className="exit-shield">🛡️</span>
          </div>

          {/* Title */}
          <h1 className="exit-title">
            Your Privacy is Protected
          </h1>

          {/* Description */}
          <div className="exit-description">
            <p style={{ 
              fontSize: '1.1rem', 
              lineHeight: '1.6', 
              color: '#666', 
              margin: '0 0 2rem 0' 
            }}>
              Thanks for chatting with S.U.E.! Your conversation has been completely
              private and will be securely stored. You can always come back to ask more questions.
            </p>
            
            <div className="privacy-guarantees">
              <div className="guarantee-item">
                <span className="guarantee-icon">🔒</span>
                <span>All data encrypted and secure</span>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-icon">🗑️</span>
                <span>Session will be safely ended</span>
              </div>
              <div className="guarantee-item">
                <span className="guarantee-icon">👤</span>
                <span>Your identity remains anonymous</span>
              </div>
            </div>

            <p className="exit-footer-text">
              If you need more help in the future, you can always start a new session. 
              Take care of yourself!
            </p>
          </div>

          {/* Action Buttons */}
          <div className="exit-actions">
            <button 
              className="exit-confirm-btn"
              onClick={onConfirm}
            >
              <span className="btn-text">End Session Safely</span>
              <span className="btn-arrow">→</span>
            </button>
            
            <button 
              className="exit-cancel-btn"
              onClick={onCancel}
            >
              Continue Chatting
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExitConfirmation; 